import React, { useEffect, useRef } from "react";

// 號召行動區元件 - 深色背景，強調下載（帶滾動動畫）
const CallToAction = ({ t }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("revealed");
          observer.unobserve(el);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="cta-section scroll-reveal" id="download" ref={ref}>
      <div className="container">
        <h2>{t.callToAction.title}</h2>
        <p>{t.callToAction.description}</p>
        <a href="https://play.google.com/store/apps/details?id=network.loki.messenger.cn&hl=zh" className="btn-primary" target="_blank" rel="noopener noreferrer">
          {t.callToAction.cta}
        </a>
      </div>
    </section>
  );
};

export default CallToAction;
